import type { RiskType } from '@/domains/academicRisk/academicRiskAction.entity';
import type { AcademicRiskActionRepository } from '@/domains/academicRisk/academicRiskAction.repository';

/**
 * Use Case para obtener tipos de riesgo académico
 *
 * Responsabilidades:
 * - Obtener tipos de riesgo desde el repositorio
 * - Actuar como intermediario entre dominio e infraestructura
 */
export class GetRiskTypesUseCase {
  private repository: AcademicRiskActionRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio que implementa AcademicRiskRepository
   */
  constructor(repository: AcademicRiskActionRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la obtención de tipos de riesgo
   * @throws Error si falla la comunicación con el repositorio
   */
  async execute(): Promise<RiskType[]> {
    return await this.repository.getRiskTypes();
  }
}
